import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox as MuiCheckbox, FormControlLabel as MuiFormControlLabel, FormHelperText as MuiFormHelperText, } from '@mui/material';
import { forwardRef } from 'react';
import { createSvgIcon, styled } from '../../utils';
import { WithEndDecorator, } from '../WithEndDecorator';
export const Checkbox = forwardRef(function CheckboxInternal(props, ref) {
    const { error, label, required, endDecorator, emptyEndDecorator, helperText, justifyContent, dataName, ...otherProps } = props;
    return (_jsxs("div", { children: [_jsx(WithEndDecorator, { alignItems: "center", justifyContent: justifyContent, endDecorator: endDecorator, emptyEndDecorator: emptyEndDecorator, decoratorComponent: _jsx(LabelStyled, { error: error, control: _jsx(CheckboxStyled, { inputRef: ref, error: error, checkedIcon: _jsx(CheckBoxChecked, {}), icon: _jsx(CheckBoxBase, {}), color: "primary", "data-name": dataName ?? null, "data-testid": dataName ?? null, ...otherProps }), label: _jsxs(_Fragment, { children: [label, required && '\xa0*'] }) }) }), helperText && _jsx(HelperTextStyled, { children: helperText })] }));
});
/* TODO: reduce icon to single path */
const CheckBoxBase = createSvgIcon(_jsxs(_Fragment, { children: [_jsx("defs", { children: _jsx("clipPath", { id: "clip-Icon_checkbox_deselected", children: _jsx("rect", { width: "20", height: "20" }) }) }), _jsxs("g", { fill: "#fff", strokeWidth: "1", children: [_jsx("rect", { width: "20", height: "20", rx: "4", stroke: "none" }), _jsx("rect", { x: "0.5", y: "0.5", width: "19", height: "19", rx: "3.5", fill: "none" })] })] }), 'CheckBoxBase');
const CheckBoxChecked = createSvgIcon(_jsxs(_Fragment, { children: [_jsx("defs", { children: _jsx("clipPath", { id: "clip-path", children: _jsx("rect", { width: "12", height: "12" }) }) }), _jsx("g", { id: "Icon_checkbox_selected", "data-name": "Icon/checkbox/selected", clipPath: "url(#clip-Icon_checkbox_selected)", children: _jsx("g", { id: "checkbox_m_selected", "data-name": "checkbox/m/selected", children: _jsxs("g", { id: "icon", transform: "translate(-159 -261)", children: [_jsx("rect", { width: "20", height: "20", rx: "4", transform: "translate(159 261)" }), _jsx("g", { transform: "translate(163 265)", children: _jsx("g", { transform: "translate(0 1.405)", children: _jsx("path", { d: "M19.441,9.508a.353.353,0,0,0-.5.045l-6.821,8.178L8.163,13.773a.353.353,0,0,0-.5.5l4.242,4.242a.353.353,0,0,0,.249.1h.017a.345.345,0,0,0,.255-.127l7.07-8.484a.353.353,0,0,0-.057-.5Z", transform: "translate(-7.575 -9.427)", fill: "#fff" }) }) })] }) }) })] }), 'CheckBoxChecked');
const CheckboxStyled = styled(MuiCheckbox, {
    shouldForwardProp: (prop) => prop !== 'error',
})(({ theme, error }) => ({
    borderRadius: theme.shape.borderRadius,
    '&.MuiCheckbox-colorPrimary': {
        // TODO: remove stroke property when using a singlepath icon
        stroke: theme.palette.primary.dark,
        color: theme.palette.primary.dark,
        '&:hover': {
            color: theme.palette.primary.light,
            // TODO: remove stroke property when using a singlepath icon
            stroke: theme.palette.primary.light,
        },
        '&.Mui-checked': {
            color: `${theme.palette.primary.dark}`,
            // TODO: remove stroke property when using a singlepath icon
            stroke: 'inherit',
            '&.Mui-disabled': {
                stroke: 'inherit',
            },
            '&:hover': {
                color: theme.palette.primary.light,
            },
        },
        '&.Mui-disabled': {
            color: theme.palette.secondary.light,
            // TODO: remove stroke property when using a singlepath icon
            stroke: theme.palette.secondary.light,
        },
        ...(error && {
            stroke: theme.palette.error.main,
            color: theme.palette.error.main,
            '&.Mui-checked': {
                color: `${theme.palette.error.main}`,
                // TODO: remove stroke property when using a singlepath icon
                stroke: 'inherit',
                '&:hover': {
                    color: theme.palette.error.light,
                    // TODO: remove stroke property when using a singlepath icon
                    stroke: 'inherit',
                },
            },
            '&:hover': {
                color: `${theme.palette.error.light}`,
                // TODO: remove stroke property when using a singlepath icon
                stroke: theme.palette.error.light,
            },
        }),
    },
    '&.Mui-checked': {
        color: error ? theme.palette.error.dark : theme.palette.primary.main,
    },
    '&.Mui-disabled': {
        color: theme.palette.secondary.light,
    },
}));
const LabelStyled = styled(MuiFormControlLabel, {
    shouldForwardProp: (prop) => prop !== 'error',
})(({ theme, error }) => ({
    marginLeft: theme.spacing(-1),
    ...(error && {
        '& .MuiFormControlLabel-label': {
            color: theme.palette.error.main,
        },
    }),
}));
const HelperTextStyled = styled(MuiFormHelperText)(({ theme }) => ({
    color: theme.palette.error.main,
}));
